import React from 'react'
import Header from '../Header/Main'
import Breadcrumb from '../Breadcrumb/Main'
import Hydrodtls from '../MenserviceHydro/Hydrodtls'
import Footer from '../Footer/Main'
import HRConsulting from '../HRConsulting/HRConsulting'

function Main() {
    return (
        <>
            <div className="page-wrapper">
                <Header />
                <Breadcrumb subtitle="Home" title="HR Consulting" />
                <HRConsulting />
                <Footer />
            </div>
        </>
    )
}

export default Main